export const getListIdRangesPerformance = (data) => {
  return data?.map((item) => item.scoreRangeId)
}

export const convertRangesPerformance = (data) => {
  const listId = getListIdRangesPerformance(data)
  const obj = {}
  listId.forEach((item) => {
    obj[item] = { ...data.find((key) => key.scoreRangeId === item) }
  })
  return obj
}

export const getIdRangesPerformanceByScore = (listData, score) => {
  const numberScore = parseInt(score)
  const dataID = listData.find(
    (item) =>
      item.scoreRange_Min <= numberScore && numberScore <= item.scoreRange_Max,
  )?.scoreRangeId
  return dataID ? dataID : 0
}
